import { render, staticRenderFns } from "./CardFlow.vue?vue&type=template&id=380c7cf0&scoped=true&"
import script from "./CardFlow.vue?vue&type=script&lang=ts&"
export * from "./CardFlow.vue?vue&type=script&lang=ts&"
import style0 from "./CardFlow.vue?vue&type=style&index=0&id=380c7cf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c7cf0",
  null
  
)

export default component.exports